import clsx from "clsx";
import { useState } from "react";
import styles from "./subMenuSpecialItem.module.scss";
import { Icon } from "@monta/design-system";
import { generatPropsTagA } from "../../../menuItem/generatPropsTagA";
import type { IMenu } from "../../../../../../constants";

interface SubMenuSpecialItemProps {
  item: IMenu;
  isLink?: boolean;
  onClick?: () => void;
  onClickIcon?: () => void;
  onCloseDrawer: () => void;
}

const SubMenuSpecialItem = (props: SubMenuSpecialItemProps) => {
  const { item, onClick, isLink, onClickIcon, onCloseDrawer } = props;
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const propTagA = generatPropsTagA(item, onClick, onCloseDrawer);
  return (
    <div className={styles["sub-menu"]} id="SubMenuSpecialItem">
      <div
        className={clsx(
          styles["sub-menu__item"],
          openSubMenu && styles["sub-menu__item--active"],
        )}
        onClick={() => (onClick ? onClick() : setOpenSubMenu(!openSubMenu))}
      >
        {isLink &&
          (propTagA.href ? (
            <a {...propTagA}>{item.title}</a>
          ) : (
            <label id="SubMenuSpecialItem-label">{item.title}</label>
          ))}
        {item.childs && (
          <Icon
            icon={"mi-Arrow-Left"}
            onClick={() =>
              onClickIcon ? onClickIcon() : setOpenSubMenu(!openSubMenu)
            }
          />
        )}
      </div>
      {!isLink && item.childs && (
        <div
          id="SubMenuSpecialItem-childs"
          className={clsx(!openSubMenu && styles["d-none"])}
        >
          <div className={styles["box"]}>
            <div className={styles["flex-center"]}>
              <div
                className={clsx(
                  styles["sub-menu__item"],
                  styles["sub-menu__item--gray"],
                  styles["sub-menu__item--spacing"],
                )}
              >
                <a {...generatPropsTagA(item, undefined, onCloseDrawer)}>
                  همه موارد دسته {item.title}
                </a>
              </div>
              <Icon icon={"mi-Arrow-Left"} />
            </div>
            {item.childs.linkList?.map((subItem) => (
              <div className={styles["sub-menu__item"]} key={subItem.linkID}>
                <a {...generatPropsTagA(subItem, undefined, onCloseDrawer)}>
                  همه موارد دسته {subItem.title}
                </a>
                {subItem.childs && <Icon icon={"mi-Arrow-Left"} />}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubMenuSpecialItem;
